// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2GqaC","header":"PatientQuestionnaire_header__17wq0","info":"PatientQuestionnaire_info__1fhC_"};